<tg-row class="summary-page-contact-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Your details</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-contact-details-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit your details</a
        >
    </tg-col>
</tg-row>
<div *ngIf="!draftData?.propertyInformation?.shouldContactAgent">
  <tg-row>
      <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
              >Mobile phone:</span
          >
          {{ mobile }}
      </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Home phone:</span
          >
      {{ landLine }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Best contact time:</span
          >
      {{ bestContactTime }}
    </tg-col>
  </tg-row>
</div>
<tg-row>
  <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Potential buyers should contact my agent:</span
          >
    {{ shouldContactMyAgent }}
  </tg-col>
</tg-row>
<tg-row *ngIf="!draftData?.propertyInformation?.shouldContactAgent">
  <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Registered property agent:</span
          >
    {{ registeredPropertyAgent }}
  </tg-col>
</tg-row>
<div *ngIf = "draftData?.propertyInformation?.isPropertyAgent">
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Your name:</span
          >
      {{ yourName }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Agency name:</span
          >
      {{ agentAgency }}
    </tg-col>
  </tg-row>
</div>
<div *ngIf="draftData?.propertyInformation?.shouldContactAgent">
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Agency name:</span
          >
      {{ agentAgency }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Agent name:</span
          >
      {{ agentName }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Mobile phone:</span
          >
      {{ agentMobile }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Landline:</span
          >
      {{ agentLandLine }}
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="summary-page-contact-details-section__content">
          <span class="summary-page-contact-details-section__content-label"
          >Email:</span
          >
      {{ agentEmail }}
    </tg-col>
  </tg-row>
</div>
